import dayjs from "dayjs"
import { RowConfig } from "../../../pages/organizationChart/pages/generalConfig/utils/types"
import { Format } from "../../../utils/types/generals"
import { getConfig } from "../response"
import { Constants } from "../../../utils/constants"

export const formatConfig = async ({ response }: { response: getConfig }): Format<getConfig, RowConfig[]> => {

    return {
        item: [],
        format: response.items?.map(config => ({
            area: config.area,
            correctiveCatalog: config.correctiveCatalog,
            date: dayjs(config.updateTime).format(Constants.dayjsFormatDate),
            department: config.department,
            id: config.id.toString(),
            preventiveCatalog: config.preventiveCatalog,
        })) || [],
        data: response
    }
}